module.exports = __webpack_public_path__ + "img/chinesecompany186.9e794ae1.png";